import { LessonProblem } from '@yandex-int/k-common';
import { Text } from 'platform-components';
import { ScrollObserver } from 'platform-components/src/components/scroll-observer/scroll-observer';
import React from 'react';

import { ProblemWithLabView } from 'common.components/lab-problem/lab-problem';
import { StackVariants, StackVariantsProps } from 'common.components/stack/__variants/stack__variants';
import { ProblemInCourse } from 'store/problems/typings';

// @ts-ignore
import cssConstants from '../constants.scss';

type OwnStackVariantsProps = 'disableProblemsInLesson';

interface OwnProps extends Omit<StackVariantsProps, OwnStackVariantsProps> {
    problems: LessonProblem[];
    selectedProblem: ProblemInCourse;
    hasVariants: boolean;
    selectedProblemIndex: number;
    modalContentRef: React.RefObject<HTMLElement>;
    handleVariantsVisibilityChange: (isVisible: boolean) => void;
}

export const StackModalVariants = (props: OwnProps) => {
    const {
        problems,
        selectedProblemIndex,
        hasVariants,
        selectedProblem,
        modalContentRef,
        handleVariantsVisibilityChange,
        cardBadges,
        stack,
        onCarouselRef,
        selectedProblemId,
        onSelectProblem,
        isMobile,
    } = props;

    if (!hasVariants) {
        return null;
    }

    return (
        <>
            <ScrollObserver
                intersectionObserverOptions={{
                    root: modalContentRef.current,
                    rootMargin: `-${cssConstants.modalMargin}`,
                }}
                onReach={() => handleVariantsVisibilityChange(true)}
                onUnreach={() => handleVariantsVisibilityChange(false)}
                scrollBorder="bottom"
            />

            <div className="stack-modal__problem-info">
                <div className="stack-modal__problem-count-info">
                    {hasVariants ? (
                        <Text
                            id="stack.problemsCountMany"
                            values={{
                                number: selectedProblemIndex + 1,
                                count: problems.length,
                            }}
                        />
                    ) : (
                        <Text id="stack.problemsCountOne" />
                    )}
                </div>
                <ProblemWithLabView.ProblemUsage problem={selectedProblem} />
            </div>

            <StackVariants
                cardBadges={cardBadges}
                disableProblemsInLesson={false}
                isMobile={isMobile}
                key={stack.id}
                mix="stack-modal__variants"
                onCarouselRef={onCarouselRef}
                onSelectProblem={onSelectProblem}
                selectedProblemId={selectedProblemId}
                stack={{ problems }}
            />
        </>
    );
};
